import { gql } from '@grandvisionhq/graphql';

var StoreByCodeFragment = gql`
  fragment StoreByCode on Store {
    code
    streetName
    streetNumber
    name
    town
  }
`;

export { StoreByCodeFragment as default };
//# sourceMappingURL=store-by-code.js.map
